export default __webpack_public_path__ + "i18n/translations/translation-he.c3061c1c.json";